/**
 * navMenu plugin — port 1:1 din legacy common.js lines 1155-1265.
 * Slide navigation cu trigger pe click + swipe left/right.
 *
 * Folosit pe paginile cu .testi-group nav (testimoniale) si .layer-3 .pagination.
 */

import { $ } from '../core/selector.js';

let busy = false;

Node.prototype.navMenu = function (this: Node, target: string, layer: string, callback?: (idx: number) => void): void {
    const navMenu = this as Element;
    const layers = $(layer, true);

    layers.forEach((item) => {
        item.classList.add('fd-slide');
        if (!item.classList.contains('active')) {
            item.classList.add('fd-hide');
        }
    });

    let index = 0;

    const navigate = (): void => {
        const navItems = navMenu.find(target, true);
        const navItem = (navItems as NodeListOf<Element>).item(index);

        navItem.siblings('.active').forEach((el) => {
            el.classList.remove('active');
        });

        navItem.classList.add('active');
        callback?.(index);

        const activeLayer = (layers as unknown as { filter: (sel: string) => Element | null }).filter('.active');
        if (!activeLayer) return;
        const display = (activeLayer as Element).getProp('display');

        (activeLayer as Element).classList.add('fd-hide');

        (activeLayer as Element).addEventListener('transitionend', function (this: Element) {
            this.classList.remove('active');
            (this as HTMLElement).style.display = 'none';

            const _layer = (layers as NodeListOf<Element>).item(index) as HTMLElement;
            _layer.style.display = display;

            setTimeout(() => {
                _layer.classList.remove('fd-hide');
            }, 0);

            _layer.addEventListener('transitionend', function (this: Element) {
                this.classList.add('active');
                busy = false;
            }, { once: true });
        }, { once: true });
    };

    this.on('click', target, function (this: Element, e: Event) {
        if (busy || this.classList.contains('active')) return;
        busy = true;
        const currentTarget = (e as Event & { currentTarget: Element }).currentTarget;
        index = this.index(currentTarget.children);
        navigate();
    });

    const parent = (layers as NodeListOf<Element>).item(0)?.parentElement;
    if (!parent) return;

    parent.on('swipeleft', () => {
        if (busy || index + 1 === (layers as NodeListOf<Element>).length) return;
        busy = true;
        index++;
        navigate();
    });

    parent.on('swiperight', () => {
        if (busy || !index) return;
        busy = true;
        index--;
        navigate();
    });
};
